import React from 'react'
import ChartInfo from "./ChartInfo";
import { Box, Grid, Typography } from '@material-ui/core';
import * as RFIcon from 'react-feather'; 
import CountBox from './CountBox';
import language from '../../../languages';

function AdminDashboardPage(props) {
    const { classes, lang } = props;

    return (
        <>
        <Grid item xs={12} md={8} className = {classes.container} >
            <Box>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={4}>
                        <Box>
                            <CountBox title={language[lang].POST_CREATED} count={12} icon={<RFIcon.Layers strokeWidth={2} color='#ffffff' size={32} />} color='#8993D1' />
                        </Box>
                    </Grid>

                    <Grid item xs={4}>
                        <Box>
                            <CountBox title={language[lang].CUSTOMERS} count={10} icon={<RFIcon.Users strokeWidth={2} color='#ffffff' size={32} />} color='#89C060' />
                        </Box>
                    </Grid>

                    <Grid item xs={4}>
                        <Box>
                            <CountBox title={language[lang].WARNINGS} count={2} icon={<RFIcon.AlertTriangle strokeWidth={2} color='#ffffff' size={32} />} color='#EA6053' />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box pt={3}>
                <Grid container justify="center">
                    <Grid item xs={12}>
                        <Box p={4} className = {classes.box}>
                            <ChartInfo chartTitle="" />
                        </Box>
                    </Grid>

                    {/* <Grid item>
                        <Paper>
                            <ChartInfo chartTitle="Daily Active Customesr" />
                        </Paper>
                    </Grid> */}
                </Grid>
            </Box>
        </Grid>
        <Grid item xs={12} md={4} >
            <Box mt={3} mr={4} className={classes.activitiesArea} style={{height: '73vh'}}>
                <Box className={classes.title}>
                    <RFIcon.Activity strokeWidth={2} /> &nbsp; &nbsp;
                    <Typography variant="subtitle2" style={{fontWeight: 'bold'}}> {language[lang].Activities} </Typography>
                </Box>
            </Box>
        </Grid>
        </>
    )
}

export default AdminDashboardPage
